// document.addEventListener("DOMContentLoaded", function () {
//   const slider = document.querySelector(".product-slider");
//   const btnLeft = document.querySelector(".btn-left");
//   const btnRight = document.querySelector(".btn-right");
//   const productSliderContainer = document.querySelector(
//     ".product-slider-container"
//   );
//   const gap = 20; // Adjust based on your CSS gap

//   // Transition configuration - smoother values
//   const TRANSITION_DURATION = 400; // ms
//   const TRANSITION_EASING = "cubic-bezier(0.25, 1, 0.5, 1)"; // Smooth easing

//   // First, save the original content
//   const originalContent = slider.innerHTML;

//   // Clone items to create infinite scrolling effect
//   // Add clones at both ends for seamless looping
//   slider.innerHTML = originalContent + originalContent + originalContent;

//   let wrappers = slider.querySelectorAll(".product-wrapper");
//   let totalProducts = wrappers.length;
//   let originalProductCount = totalProducts / 3; // We have 3 sets now

//   let productWidth = wrappers[0].offsetWidth + gap;
//   let currentTranslate = -originalProductCount * productWidth; // Start in the middle set
//   let isDragging = false;
//   let startX = 0;
//   let prevTranslate = 0;
//   let animationFrameId = null;
//   let scrollDirection = 0; // -1: left, 1: right, 0: no scroll
//   let autoScrollSpeed = 4; // pixels per frame when auto scrolling
//   let isTransitioning = false;
//   let lastTime = 0;
//   let velocity = 0;

//   // Set initial position to middle set of items
//   slider.style.transform = `translateX(${currentTranslate}px)`;

//   // Update sizes on window resize
//   function updateSizes() {
//     productWidth = wrappers[0].offsetWidth + gap;
//     // Re-center to middle set when resizing
//     // currentTranslate = -Math.round(originalProductCount * productWidth / 2);
//     slider.style.transition = "none";
//     slider.style.transform = `translateX(${currentTranslate}px)`;

//     adjustClickable();
//   }

//   window.addEventListener("resize", updateSizes);
//   // Run once to set initial sizes
//   setTimeout(updateSizes, 100);

//   function setTranslate(x, withTransition = true) {
//     if (isTransitioning && withTransition) return;

//     currentTranslate = x;

//     // If we want animation and not dragging
//     if (withTransition && !isDragging) {
//       slider.style.transition = `transform ${TRANSITION_DURATION}ms ${TRANSITION_EASING}`;
//       isTransitioning = true;

//       // Apply the transform
//       slider.style.transform = `translateX(${currentTranslate}px)`;

//       // Reset the transition state after animation completes
//       setTimeout(() => {
//         checkInfiniteJump();
//       }, TRANSITION_DURATION);
//     } else {
//       // No animation, just move
//       slider.style.transition = "none";
//       slider.style.transform = `translateX(${currentTranslate}px)`;
//     }
//   }

//   // Handle the "jump" for infinite scrolling effect
//   function checkInfiniteJump() {
//     const totalWidth = productWidth * originalProductCount;

//     // Calculate boundaries for the middle set
//     const rightBoundary = -productWidth;
//     const leftBoundary = -(totalWidth * 2) + productWidth;

//     slider.style.transition = "none";

//     // If we've scrolled too far right (into the first set), jump to equivalent position in middle set
//     if (currentTranslate > rightBoundary) {
//       currentTranslate -= totalWidth;
//       slider.style.transform = `translateX(${currentTranslate}px)`;
//     }
//     // If we've scrolled too far left (into the third set), jump to equivalent position in middle set
//     else if (currentTranslate < leftBoundary) {
//       currentTranslate += totalWidth;
//       slider.style.transform = `translateX(${currentTranslate}px)`;
//     }

//     // Force browser to process the style change
//     slider.offsetHeight;

//     isTransitioning = false;
//   }

//   // Improved continuous scroll animation with time-based logic
//   function autoScroll(timestamp) {
//     if (!lastTime) lastTime = timestamp;
//     const deltaTime = timestamp - lastTime;
//     lastTime = timestamp;

//     if (scrollDirection !== 0 && !isDragging && !isTransitioning) {
//       // Gradually increase/decrease velocity for smoother starts/stops
//       const targetVelocity = scrollDirection * autoScrollSpeed;
//       const acceleration = 0.2;

//       // Ease towards target velocity
//       velocity += (targetVelocity - velocity) * acceleration;

//       // Apply time-based movement
//       const movement = velocity * (deltaTime / 16); // normalized to ~60fps
//       setTranslate(currentTranslate + movement, false);

//       // Check if we need to reset position for infinite loop
//       if (!isTransitioning) {
//         checkInfiniteJump();
//       }
//     } else if (scrollDirection === 0 && Math.abs(velocity) > 0.1) {
//       // Gradually slow down
//       velocity *= 0.9;
//       const movement = velocity * (deltaTime / 16);
//       setTranslate(currentTranslate + movement, false);
//     } else if (scrollDirection === 0) {
//       velocity = 0;
//     }

//     animationFrameId = requestAnimationFrame(autoScroll);
//   }

//   // Start animation loop
//   animationFrameId = requestAnimationFrame(autoScroll);

//   // Button click handlers - use function() for compatible event handling
//   btnLeft.addEventListener("click", function () {
//     if (isTransitioning) return;
//     scrollDirection = 0; // Stop auto-scrolling
//     velocity = 0;
//     setTranslate(currentTranslate + productWidth);
//   });

//   btnRight.addEventListener("click", function () {
//     if (isTransitioning) return;
//     scrollDirection = 0; // Stop auto-scrolling
//     velocity = 0;
//     setTranslate(currentTranslate - productWidth);
//   });

//   // Prevent default image drag behavior
//   const images = slider.querySelectorAll(".product img");
//   images.forEach(function (image) {
//     image.addEventListener("dragstart", function (e) {
//       e.preventDefault();
//     });
//   });

//   // Stop scrolling on mouse up/leave
//   function stopScroll() {
//     scrollDirection = 0;
//   }

//   // Button hold for continuous scrolling
//   btnLeft.addEventListener("mousedown", function () {
//     scrollDirection = 1;
//   });
//   btnLeft.addEventListener("mouseup", stopScroll);
//   btnLeft.addEventListener("mouseleave", stopScroll);
//   btnRight.addEventListener("mousedown", function () {
//     scrollDirection = -1;
//   });
//   btnRight.addEventListener("mouseup", stopScroll);
//   btnRight.addEventListener("mouseleave", stopScroll);

//   // Touch events for mobile
//   btnLeft.addEventListener(
//     "touchstart",
//     function (e) {
//       e.preventDefault();
//       scrollDirection = 1;
//     },
//     { passive: false }
//   );
//   btnLeft.addEventListener(
//     "touchend",
//     function (e) {
//       e.preventDefault();
//       scrollDirection = 0;
//     },
//     { passive: false }
//   );
//   btnRight.addEventListener(
//     "touchstart",
//     function (e) {
//       e.preventDefault();
//       scrollDirection = -1;
//     },
//     { passive: false }
//   );
//   btnRight.addEventListener(
//     "touchend",
//     function (e) {
//       e.preventDefault();
//       scrollDirection = 0;
//     },
//     { passive: false }
//   );

//   // Drag behavior with inertia
//   let dragVelocity = 0;
//   let lastDragX = 0;
//   let lastDragTime = 0;

//   function dragStart(event) {
//     if (isTransitioning) return;
//     isDragging = true;
//     startX = event.type.includes("mouse")
//       ? event.pageX
//       : event.touches[0].clientX;
//     lastDragX = startX;
//     lastDragTime = Date.now();
//     prevTranslate = currentTranslate;
//     slider.style.transition = "none";
//     scrollDirection = 0; // pause auto scroll
//     velocity = 0; // Reset auto-scroll velocity
//     dragVelocity = 0;

//     // Stop any ongoing animations
//     cancelAnimationFrame(animationFrameId);
//   }

//   function dragMove(event) {
//     if (!isDragging) return;

//     const currentX = event.type.includes("mouse")
//       ? event.pageX
//       : event.touches[0].clientX;
//     const diffX = currentX - startX;

//     // Calculate drag velocity for inertia effect
//     const now = Date.now();
//     const dt = now - lastDragTime;
//     if (dt > 0) {
//       dragVelocity = ((currentX - lastDragX) / dt) * 15; // Scale factor
//     }

//     lastDragX = currentX;
//     lastDragTime = now;

//     setTranslate(prevTranslate + diffX, false);
//   }

//   function dragEnd() {
//     if (!isDragging) return;
//     isDragging = false;

//     // Apply inertia for a natural feel if drag was fast enough
//     if (Math.abs(dragVelocity) > 0.5) {
//       // Predict where slide would end with inertia
//       const predictedPosition = currentTranslate + dragVelocity * 100;
//       const snapPosition =
//         Math.round(predictedPosition / productWidth) * productWidth;
//       setTranslate(snapPosition);
//     } else {
//       // Just snap to nearest product without inertia
//       const snapPosition =
//         Math.round(currentTranslate / productWidth) * productWidth;
//       setTranslate(snapPosition);
//     }

//     // Check if we need to jump to maintain infinite loop
//     checkInfiniteJump();

//     // Restart animation loop
//     lastTime = 0;
//     animationFrameId = requestAnimationFrame(autoScroll);
//   }

//   // Add event listeners for dragging
//   productSliderContainer.addEventListener("mousedown", dragStart);
//   productSliderContainer.addEventListener("touchstart", dragStart, {
//     passive: false,
//   });
//   productSliderContainer.addEventListener("mousemove", dragMove);
//   productSliderContainer.addEventListener("touchmove", dragMove, {
//     passive: false,
//   });
//   productSliderContainer.addEventListener("mouseup", dragEnd);
//   productSliderContainer.addEventListener("touchend", dragEnd);
//   productSliderContainer.addEventListener("mouseleave", dragEnd);

//   // Handle product clickability based on viewport
//   function adjustClickable() {
//     const wrappers = slider.querySelectorAll(".product-wrapper");

//     // Mobile design
//     if (window.innerWidth <= 1024) {
//       btnLeft.style.display = "none";
//       btnRight.style.display = "none";

//       // Make wrappers clickable on mobile
//       wrappers.forEach(function (wrapper) {
//         const url = wrapper.getAttribute("data-url");
//         wrapper.style.cursor = "pointer";
//         wrapper.onclick = function () {
//           window.location.href = url;
//         };
//       });
//     } else {
//       // Desktop design
//       btnLeft.style.display = "block";
//       btnRight.style.display = "block";

//       wrappers.forEach(function (wrapper) {
//         wrapper.style.cursor = "default";
//         wrapper.onclick = null;
//       });
//     }
//   }

//   adjustClickable();
//   window.addEventListener("resize", adjustClickable);
// });

// // Keep your existing cart functionality unchanged
// $("body").on("click", ".productinfo_add_to_cart_index", function (e) {
//   e.preventDefault();

//   var _vid = $(this).attr("data-id");
//   var _items = [{ quantity: 1, id: _vid }];
//   var button = $(this);
//   var loader = $(this).closest(".product-details").find(".loaderrr");

//   button.css("opacity", "0.5");

//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: JSON.stringify({ items: _items }),
//     contentType: "application/json",
//     dataType: "json",

//     success: function (msg) {
//       button.show();
//       loader.hide();

//       var productButton = $(
//         '.standard_button_index[data-id="' + _items[0].id + '"]'
//       );

//       productButton.css({
//         opacity: "1",
//         "background-image":
//           'url("https://cdn.shopify.com/s/files/1/0878/7660/0115/files/shopping-cart.png?v=1738079598")',
//         width: "32px",
//         height: "32px",
//       });

//       var _count =
//         $("#items_in_cart_count").html() != ""
//           ? parseInt($("#items_in_cart_count").html()) + 1
//           : 1;
//       if (_count > 0) {
//         $(".icon-bag").addClass("active");
//       }
//       $("#items_in_cart_count, .cart_bubble").html(_count);
//       $(".cart_bubble").addClass("active");
//     },

//     error: function (xhr, status, error) {
//       console.error("Error adding to cart:", error);
//       button.show();
//       loader.hide();
//     },
//   });
// });

function adjustFemaleWatchHeights() {
  document.querySelectorAll(".product-wrapper-div").forEach(wrapper => {
    const filters = wrapper.getAttribute("data-filters")?.toLowerCase() || "";
    if (filters.includes("ladies") || filters.includes("ladies'") || filters.includes("women")) {
      
      const img = wrapper.querySelector(".product-wrapper-images");
      const productDiv = wrapper.querySelector(".product");

      if (window.innerWidth == 320) {
          if (img) img.style.height = "180px";
          if (productDiv) productDiv.style.height = "270px";
        }
        else if (window.innerWidth <= 480) {
          if (img) img.style.height = "190px";
          if (productDiv) productDiv.style.height = "270px";
        } 
        else if (window.innerWidth <= 580) {
          if (img) img.style.height = "200px";
          if (productDiv) productDiv.style.height = "270px";
        } 
        else if (window.innerWidth <= 768) {
          if (img) img.style.height = "235px";
          if (productDiv) productDiv.style.height = "300px";
        } 
        else if (window.innerWidth <= 940) {
          if (img) img.style.height = "200px";
          if (productDiv) productDiv.style.height = "270px";
        } 
        else if (window.innerWidth <= 1044) {
          if (img) img.style.height = "235px";
          if (productDiv) productDiv.style.height = "320px";
        } 
        else if (window.innerWidth <= 1140) {
          if (img) img.style.height = "230px";
          if (productDiv) productDiv.style.height = "350px";
        } 
        else if (window.innerWidth >= 1600) {
          if (img) img.style.height = "300px";
          if (productDiv) productDiv.style.height = "460px";
        } 
        else if (window.innerWidth >= 2200) {
          if (img) img.style.height = "320px";
          // if (productDiv) productDiv.style.height = "460px";
        } 
        else {
          if (img) img.style.height = "265px";
          if (productDiv) productDiv.style.height = "370px";
        }

      // Always center content
      if (productDiv) {
        productDiv.style.justifyContent = "center";
        productDiv.style.display = "flex";
      }
    }
  });
}

// Run once on page load
document.addEventListener("DOMContentLoaded", adjustFemaleWatchHeights);

// Run again whenever screen is resized
window.addEventListener("resize", adjustFemaleWatchHeights);


// Ali Khan code start here
document.addEventListener("DOMContentLoaded", function () {
  function setupProductSlider(
    containerSelector,
    sliderSelector,
    btnLeftSelector,
    btnRightSelector,
    productWidth = 260
  ) {
    const container = document.querySelector(containerSelector);
    const slider = container.querySelector(sliderSelector);
    const btnLeft = container.querySelector(btnLeftSelector);
    const btnRight = container.querySelector(btnRightSelector);
    const scrollAmount = productWidth * 2; // Scroll 2 products
    const originalContent = slider.innerHTML;

    function scrollSlider(direction) {
      const distance = direction === "right" ? scrollAmount : -scrollAmount;

      // Instant, responsive, smooth scroll
      slider.scrollBy({
        left: distance,
        behavior: "smooth",
      });

      // Check for infinite content
      if (
        slider.scrollLeft + container.offsetWidth + 300 >=
        slider.scrollWidth
      ) {
        slider.innerHTML += originalContent;
      }
    }

    btnLeft.addEventListener("click", () => scrollSlider("left"));
    btnRight.addEventListener("click", () => scrollSlider("right"));

    // Infinite clone when manually scrolled
    slider.addEventListener("scroll", () => {
      if (
        slider.scrollLeft + container.offsetWidth + 300 >=
        slider.scrollWidth
      ) {
        slider.innerHTML += originalContent;
      }
    });
  }

  // Initialize Best Sellers
  setupProductSlider(
    "#best-seller-product-slider-container",
    ".product-slider",
    ".btn-left",
    ".btn-right"
  );

  // Initialize New Arrivals
  setupProductSlider(
    "#new-arrival-product-slider-container",
    ".product-slider-new",
    ".btn-left-new",
    ".btn-right-new"
  );
});

// Keep your existing cart functionality unchanged
$("body").on("click", ".productinfo_add_to_cart_index", function (e) {
  e.preventDefault();

  var _vid = $(this).attr("data-id");
  var _items = [{ quantity: 1, id: _vid }];
  var button = $(this);
  var loader = $(this).closest(".product-details").find(".loaderrr");

  button.css({
    "opacity": "0.5",
    "pointer-events": "none"
  }).attr("disabled", true);
  
  // button.css("opacity", "0.5");

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify({ items: _items }),
    contentType: "application/json",
    dataType: "json",

    success: function (msg) {
      button.show();
      loader.hide();

      var productButton = $(
        '.standard_button_index[data-id="' + _items[0].id + '"]'
      );

      productButton.css({
        opacity: "1",
        "background-image":
          'url("https://cdn.shopify.com/s/files/1/0878/7660/0115/files/shopping-cart.png?v=1738079598")',
        width: "32px",
        height: "32px",
      });

      var _count =
        $("#items_in_cart_count").html() != ""
          ? parseInt($("#items_in_cart_count").html()) + 1
          : 1;
      if (_count > 0) {
        $(".icon-bag").addClass("active");
      }
      $("#items_in_cart_count, .cart_bubble").html(_count);
      $(".cart_bubble").addClass("active");
    },

    error: function (xhr, status, error) {
      console.error("Error adding to cart:", error);
      button.show();
      loader.hide();
    },
  });
});
